import script from "./Article.vue?vue&type=script&setup=true&lang=js"
export * from "./Article.vue?vue&type=script&setup=true&lang=js"

import "./Article.vue?vue&type=style&index=0&id=523423ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-523423ca"]])

export default __exports__